import React from 'react';
import $ from 'jquery';
// import 'slick-carousel';
import 'Assets/thirdparty/slick-1.8.1/slick/slick';
import ReactResizeDetector from 'react-resize-detector';
import { Portal } from 'react-portal';


import Product from './Product';
import ProductPopup from './ProductPopup';

import './ProductsSlider.module.css';

import ArrowLeft from 'Assets/images/arrow_left.png';
import ArrowRight from 'Assets/images/arrow_right.png';

class ProductsSlider extends React.Component {

  state = {
    sliderWidth: 1100,
    sliderHeight: 440,
    slidesPerRow: 5,
    rows: 2,
    productWidth: 220,
    mobilePreviousButton: false,
    selectedProduct: false
  };

  componentDidMount() {
      this.$el = $(this.el);
      setTimeout(() => {
        this.initSlider();
      }, 200);

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('click', this.handleOutsideMouseClick);
      }
  }

  componentWillUnmount() {
    this.removeSlider();
  }

  slidePrevious = () => {
    this.$el.slick('slickPrev');
  }

  slideNext = () => {
    this.$el.slick('slickNext');
  }

  initSlider = () => {
    if (typeof window !== 'undefined') {
      try {
        this.$el.slick({
          dots: false,
          infinite: true,
          speed: 500,
          arrows: false,
          autoplay: false,
          autoPlaySpeed: 1000,
          slidesToShow: this.state.slidesPerRow,
          slidesToScroll: this.state.slidesPerRow,
          rows: this.state.rows,
        });
        this.$el.on('afterChange', function(event, slick, currentSlide){
          let height = 0;
          let width = 0;
          var prev = "previous_element_content";
          $('.slick-slide > div').each((i, element) => {
            if (!$(element).html()) {
              $(element).addClass("empty");
              if (prev) {
                $(element).addClass("first");
              }
              $(element).css({width: width, height: height});
            } else {
              width = $(element).width() + 2;
              height = $(element).height();
            }
            prev = $(element).html();
          });
        });
      } catch (e) {
        console.error("Error initializing slider");
        console.log(e);
      }
    }
  }

  removeSlider = () => {
    if (typeof window !== 'undefined' && this.$el) {
      try {
        this.$el.slick('unslick');
      } catch (e) {
        console.error("Error during removing slider");
      }
    }
  }

  onResize = (width) => {
    // we need to substract the buttons left and right from the full width
    let slidesPerRow = 2;
    let rows = 4;
    let sliderWidth = width;
    let sliderHeight = sliderWidth / 480 * 960;
    let mobilePreviousButton = true;
    if (sliderWidth > 920) {
      slidesPerRow = 5;
      rows = 2;
      sliderWidth = width - 100;
      sliderHeight = sliderWidth / 1200 * 480;
      mobilePreviousButton = false;
    } else if (sliderWidth > 740) {
      slidesPerRow = 4;
      rows = 2;
      sliderWidth = width - 100;
      sliderHeight = sliderWidth / 960 * 480;
      mobilePreviousButton = false;
    } else if (sliderWidth < 300) {
      slidesPerRow = 1;
      rows = 2;
      sliderWidth = width;
      sliderHeight = sliderWidth / 480 * 960;
      mobilePreviousButton = true;
    }

    this.setState({
      sliderWidth: sliderWidth,
      sliderHeight: sliderHeight,
      productWidth: sliderWidth / slidesPerRow,
      productHeight: sliderHeight / rows,
      slidesPerRow: slidesPerRow,
      rows: rows,
      mobilePreviousButton: mobilePreviousButton
    });
    this.removeSlider();
    //setTimeout(() => {
      this.initSlider();
    //}, 100);
  }

  productSelected = (product) => {
    this.setState({
      selectedProduct: product
    });
  }

  closePopup = () => {
    this.setState({
      selectedProduct: false
    });
  }



  render() {
    return (
      <div style={{display: "block"}}>
        <ReactResizeDetector handleWidth handleHeight onResize={this.onResize} />
        { !this.state.mobilePreviousButton &&
          <a styleName="previousButton" onClick={this.slidePrevious} style={{
            height: this.state.sliderHeight
          }}>
            <img styleName="arrow" src={ArrowRight} alt="Zurück" />
          </a>
        }
        <div
          ref={(el) => { this.el = el; }}
          className="productSlider"
          style={{
            height: this.state.sliderHeight,
            width: this.state.sliderWidth,
            float: "left",
          }}
        >
          {
            this.props.data.map(({ node }) => (
              <div key={node.id} styleName="productContainer">
                <Product data={node}
                         width={this.state.productWidth}
                         onClick={this.productSelected }
                />
              </div>
            ))
          }
        </div>
        { !this.state.mobilePreviousButton &&
          <a styleName="nextButton" onClick={this.slideNext}
             style={{
               height: this.state.sliderHeight
             }}
          >
            <img styleName="arrow" src={ArrowLeft} alt="Vor" />
          </a>
        }
        { this.state.mobilePreviousButton && (
          <div styleName="mobileButtonContainer">
            <a styleName="mobilePreviousButton" onClick={this.slidePrevious}>
             <img styleName="arrow" src={ArrowRight} alt="Zurück" />
            </a>
            <a styleName="mobileNextButton" onClick={this.slideNext}>
              <img styleName="arrow" src={ArrowLeft} alt="Vor" />
            </a>
          </div>
        )}

        { this.state.selectedProduct &&
          <ProductPopup selectedProduct={this.state.selectedProduct}
            onClose={this.closePopup}
          />

        }

      </div>
    );
  }
}

export default ProductsSlider;


// WEBPACK FOOTER //
// ./src/components/Products/ProductsSlider.js